import React from "react";
import styles from "./BreadCrumbs.module.scss"
import {LocationContext} from "../../../architecture/LocationContext/LocationContext";

const BreadCrumbs = ({ breadcrumbs}) => {

    const { setCurrentLocation, currentLocation, resetSegment } = React.useContext(LocationContext)
    const handleNavigation = (breadcrumb, key) => {
        const newLocation = {...currentLocation}
        switch(key) {
            case 'module':
                newLocation['module'] = 0;
                newLocation['lesson'] = 0;
                newLocation['chapter'] = 0;
                newLocation['segment'] = 0;
                setCurrentLocation(newLocation)
                break;
            case 'lesson':
                newLocation['chapter'] = 0;
                newLocation['segment'] = 0;
                setCurrentLocation(newLocation)
                break;
            case 'segment':
                resetSegment();
                break;
        }
    }

    const setAsHtml = (breadcrumb, key) => {
        let caption = ''
        switch(key) {
            case 'module':
                caption = breadcrumb[key]?.name || ''
                break;
            case 'lesson':
                caption = breadcrumb[key]?.name || ''
                break;
            case 'segment':
                caption = breadcrumb[key]?.title || ''
                break;
        }
        return { __html: caption };


    }

    return (
        <div className={styles.BreadCrumbs}>
           <>
                {
                    Object.keys(breadcrumbs).map((key, index) => (
                        (breadcrumbs[key].name || breadcrumbs[key].type || breadcrumbs[key].title) &&
                        <a
                            key={index}
                            onClick={() => handleNavigation(breadcrumbs[key], key)}
                            dangerouslySetInnerHTML={setAsHtml( breadcrumbs, key   )}
                        />

                    ))
                }
            </>
        </div>
    )
}
export default BreadCrumbs;
